import React, { useContext } from 'react';
import { DeviceAuthContext } from '../providers/DevicesAuthProvider';
import { Navigate, useParams } from 'react-router-dom';
import { PATH_APP } from '../routes';

export default function AuthGuard({ children }) {
  const { isAuthenticating, isAuthenticated } = useContext(DeviceAuthContext);
  const { tenant } = useParams();
  if (isAuthenticating) {
    return <></>;
  }
  if (!isAuthenticated) {
    return <Navigate to={PATH_APP.connect(tenant)} />;
  }

  return <>{children}</>;
}
